// extracted by mini-css-extract-plugin
module.exports = {"classes":"\"../../../themes/theme.module.css\"","lake25":"#DFF9FF","ItemText":"PulldownMenu_ItemText__AeeDq"};